import { IconProps, Icon } from '@chakra-ui/react';

export const PortalIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d={props.path} />
  </Icon>
);
